import api from "@/config/apiConfig"

class MessagesController {

  async index(req = {}) {
    try {
      const { ticketId, page = 1 } = req;
      const response = await api.get(`messages`, {
        params: {
          ticketId,
          page
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro no MessagesController.index: ", error);
      throw error;
    }
  }
  async editMessage(req = {}) {
    const { body, read = 1, medias, messageId, fromMe = true, quotedMsg } = req;

    try {
      let response;

      if (medias) {
        // Envio como FormData quando há mídias
        const formData = new FormData();
        formData.append('body', body);
        formData.append('fromMe', fromMe);
        formData.append('read', read);
        formData.append('quotedMsg', quotedMsg || null);
        formData.append('medias', medias);
        response = await api.post(`messages/edit/${messageId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Envio como JSON quando não há mídias
        const payload = {
          body,
          read,
          quotedMsg,
          fromMe
        };

        response = await api.post(`messages/edit/${messageId}`, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }

      return response.data;
    } catch (error) {
      console.error('Erro no MessagesController.editMessage: ', error);
      throw error;
    }
  }

  async sendMessage(req = {}) {
    const { body, fromMe = true, ticketId, quotedMsg, medias, template = null } = req;

    try {
      let response;

      if (medias) {
        // Envio como FormData quando há mídias
        const formData = new FormData();
        formData.append('body', body);
        formData.append('fromMe', fromMe);
        formData.append('quotedMsg', quotedMsg || null);
        formData.append('medias', medias);
        formData.append('ticketId', ticketId);

        response = await api.post(`messages`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Envio como JSON quando não há mídias
        const payload = {
          body,
          fromMe,
          quotedMsg: quotedMsg || null,
          ticketId,
          template
        };

        response = await api.post(`messages`, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }

      return response.data;
    } catch (error) {
      console.error('Erro no MessagesController.sendMessage: ', error);
      throw error;
    }
  }
  async deleteMessage(messageId) {
    try {
      const response = await api.delete(`messages/${messageId}`)
      return response.data;
    } catch (error) {
      console.error('Erro no MessagesController.deleteMessage: ', error);
      throw error
    }
  }

  async retryDownload(messageId) {
    try {
      const response = await api.post(`messages/${messageId}/retry-download`);
      return response.data;
    } catch (error) {
      console.error('Erro no MessagesController.retryDownload: ', error);
      throw error;
    }
  }

}



export default new MessagesController();